<template>
  <!-- 佣金设置 -->
  <div>
    <div class="setting-top">
      <span class="label">启用提成计算</span>
      <el-switch
        v-model="delivery"
        :active-value="1"
        :inactive-value="0"
        @change="saveAppserviceStatus"
      />
    </div>
    <div class="f-search-block">
      <div class="search-items">
        <div class="field-item">
          <div class="field-item-label">
            业绩提成规则设置
          </div>
        </div>
      </div>
      <div class="search-btns">
        <el-button
          type="primary"
          :loading="submitSaveLoading"
          @click="saveSetting"
        >
          保存设置
        </el-button>
      </div>
    </div>
    <!-- 内容区 -->
    <div class="f-toolbar-block">
      <el-form
        ref="form"
        :model="form"
        label-width="150px"
      >
        <!-- <el-form-item
          label="提成计算条件"
          prop="count_filter"
        > 
          <span>订单完成后 </span>         
          <el-input
            v-model.number="form.count_filter"
            placeholder="业绩"
            style="width:200px"
          >
            <template slot="append">
              天
            </template>
          </el-input>  
        </el-form-item> -->
        <el-form-item label="员工提成类型">
          <el-radio-group v-model="form.rule_type">
            <el-radio :label="1">
              按门店业绩档位提点
            </el-radio>
            <el-radio :label="2">
              按员工业绩档位提成
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <div slot="label">
            <span>员工提成比例</span>
            <el-tooltip
              placement="top"
              style="margin-left: 8px"
            >
              <div slot="content">
                基于员工个人业绩的佣金提点比例
              </div>
              <i class="el-icon-info" />
            </el-tooltip>
          </div>

          <el-table
            :data="commissionSettingList"
            style="width: 100%"
            border
          >
            <el-table-column
              prop="ladder_value"
              label="业绩档位"
              width="350"
            >
              <template slot-scope="scope">
                <span v-if="scope.$index === 0">基础档</span>
                <div
                  v-else
                  class="flex"
                >
                  <span>当月业绩大于</span>
                  <el-input
                    v-model="scope.row.ladder_value"
                    type="number"
                    class="m-l-6"
                    placeholder="业绩"
                    style="width: 180px"
                    :min="0"
                    @input="changeLadderValue(arguments[0], scope.$index)"
                  >
                    <template slot="append">
                      元
                    </template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="proportion"
              label="提点比例"
            >
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.proportion"
                  placeholder="提点比例"
                  style="width: 150px"
                >
                  <template slot="append">
                    %
                  </template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="proportion">
              <template slot="header">
                特定商品提成
                <el-tooltip placement="top">
                  <div slot="content">
                    基于员工个人业绩的佣金提点比例
                  </div>
                  <i class="el-icon-info" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <el-button
                  v-if="!scope.row.newAdd && form.id > 0"
                  type="primary"
                  size="mini"
                  @click="uploadGoods(scope.row)"
                >
                  上传特定商品
                </el-button>
                <el-button
                  v-if="scope.row.is_upload"
                  type="text"
                  @click="showGoodsList(scope.row)"
                >
                  已上传
                </el-button>
                <el-button
                  v-if="scope.row.is_upload"
                  type="text"
                  @click="cleanGoodsList(scope.row)"
                >
                  清除
                </el-button>
                <!-- 选择商品 -->
                <SpRulesGoodsSelect
                  v-model="scope.row.goodsVisible"
                  :rule-id="form.id"
                  :ladder-no="scope.row.ladder_no"
                />
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="100"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="scope.$index > 0"
                  type="text"
                  size="mini"
                  @click="changeCommissionSettingList('del', scope.$index, scope.row)"
                >
                  <!-- style="font-size:20px;color:#999;" -->
                  <!-- <i class="el-icon-remove" /> -->
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="margin-top: 6px">
            <el-button
              plain
              type="primary"
              @click="changeCommissionSettingList('add')"
            >
              添加提点档位
            </el-button>
          </div>
        </el-form-item>

        <el-form-item>
          <div slot="label">
            <span>编外提成比例</span>
            <el-tooltip
              placement="top"
              style="margin-left: 8px"
            >
              <div slot="content">
                基于编外个人业绩的佣金提点比例
              </div>
              <i class="el-icon-info" />
            </el-tooltip>
          </div>

          <el-input
            v-model="form.supernumerary"
            placeholder="提点比例"
            style="width: 200px"
          >
            <template slot="append">
              %
            </template>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 批量导入 -->
    <SpBulkImport
      v-model="importVisible"
      file-type="item_commission"
      title="批量导入商品"
      :add-params="{
        rel_data: { rule_id: form.id, ladder_no: editItemObject.ladder_no }
      }"
      @saveImportAction="saveImportAction"
    >
      <div>
        批量导入说明：<br>
        1、导出商品佣金设置文件，导出成功后下载文件<br>
        2、根据填写要求填写商品规格佣金信息，上传并导入文件，文件格式必须为xlsx<br>
        3、单次上传xlsx最大条目数（行数）为5000<br>
        4、上传后系统将校验文件内容格式，如有误，需根据提示修改后重新上传
      </div>
    </SpBulkImport>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        commissionType: null, //提成类型
        commissionSetting: false //启用提成计算,
        // count_filter:null,//编外提成比例
      },
      importVisible: false,
      submitSaveLoading: false,
      commissionSettingList: [
        {
          ladder_no: 0, //档位编号
          ladder_value: 0, //档位条件值
          proportion: null, //提点比例
          is_upload: false, //上传特定商品
          goodsVisible: false
        }
      ],
      // 添加提点档位；
      addSetItemForm: {
        ladder_no: 0, //档位编号
        ladder_value: null, //档位条件值
        proportion: null, //提点比例
        is_upload: false, //上传特定商品
        goodsVisible: false,
        newAdd: true
      },
      delivery: false, // 是否启用提成计算
      editItemObject: {}
    }
  },
  mounted () {
    this.initSetting()
  },
  methods: {
    initSetting () {
      this.getDelivery()
      this.getSetting()
    },
    async getDelivery () {
      const data = await this.$api.customerConversion.getAppserviceStatus({
        name: 'commission'
      })
      if (data) {
        this.delivery = data.status
      }
    },
    async getSetting () {
      const data = await this.$api.customerConversion.getDefaultSetting()
      if (data) {
        data.staff_ladder_proportion.forEach((v) => {
          v.goodsVisible = false
        })
        this.commissionSettingList = data.staff_ladder_proportion
        console.log(this.commissionSettingList, 'this.commissionSettingList')
        this.form = data
      }
    },

    // 设置
    async saveAppserviceStatus (value) {
      const data = await this.$api.customerConversion.saveAppserviceStatus({
        name: 'commission',
        status: value
      })
      if (data) {
        this.$message.success('设置成功！')
      }
    },

    // 变更 门店提点list
    changeCommissionSettingList (type, index, item) {
      if (type === 'add') {
        let params = {
          ...this.addSetItemForm
        }
        this.commissionSettingList.push(JSON.parse(JSON.stringify(params)))
      } else {
        this.commissionSettingList.splice(index, 1)
        if (item.is_upload) {
          this.cleanGoodsList(item, 'del')
        }
      }
    },
    // 保存配置
    async saveSetting () {
      for (let i = 0; i < this.commissionSettingList.length; i++) {
        if (i > 0) {
          if (
            this.commissionSettingList[i].ladder_value <=
            this.commissionSettingList[i - 1].ladder_value
          ) {
            return this.$message.error('当前业绩需大于上一个档位的业绩！')
          }
        }
      }

      let staff_ladder_proportion = []
      this.commissionSettingList.forEach((v, i) => {
        staff_ladder_proportion.push({
          ladder_no: i + 1,
          ladder_value: v.ladder_value,
          proportion: v.proportion
        })
      })

      const params = { ...this.form, staff_ladder_proportion }
      const data = await this.$api.customerConversion.saveDefaultSetting(params)
      if (data) {
        this.$message.success('保存成功！')
        this.initSetting()
      }
    },

    // 列表多选
    handleSelectionChange (val) {
      this.multipleSelection = val
    },

    // 上传商品
    uploadGoods (item) {
      this.importVisible = true
      this.editItemObject = item
    },

    // 确定导入
    saveImportAction () {
      this.editItemObject.is_upload = true
    },

    // 展示已上传的商品列表
    showGoodsList (item) {
      item.goodsVisible = true
      this.editItemObject = item
    },

    changeLadderValue (value, index) {
      let num = value
      if (num.length == 1) {
        num = num.replace(/[^1-9]/g, '')
      } else {
        num = num.replace(/\D/g, '')
      }

      this.commissionSettingList[index].ladder_value = Number(num)
      this.$nextTick(() => {
        let newVal = Math.max(Number(num), 0)
        this.commissionSettingList[index].ladder_value = Number(newVal)
      })
    },

    // 清除已上传的数据
    async cleanGoodsList (item, type) {
      const data = await this.$api.customerConversion.cleanCommissionList({
        rule_id: this.form.id,
        ladder_no: item.ladder_no
      })
      if (data && data.status) {
        if (type === 'del') {
          this.$message.success('删除成功')
        } else {
          this.$message.success('清除成功')
        }
        item.is_upload = false
      } else {
        this.$message.error('清除失败')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-table {
  &-title {
    display: flex;
    text-align: left;
  }
  &-item {
    display: flex;
    text-align: left;
    margin-bottom: 10px;
  }
}
.flex {
  display: flex;
  align-items: center;
}
.setting-top {
  padding: 14px 24px;
  background: #fff;
  margin-bottom: 20px;
  .label {
    width: 100px;
    margin-right: 12px;
  }
}
.m-l-6 {
  margin-left: 6px;
}
</style>
